import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Alert,
  Button,
  CircularProgress,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useResetClientPinMutation } from '../queries';
import { FormattedMessage, useIntl } from 'react-intl';

export const ResetPinPage = () => {
  const intl = useIntl();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { mutate, isPending, isSuccess } = useResetClientPinMutation();

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    if (pin.length < 4 || pin.length > 20)
      return setError(intl.formatMessage({ id: 'resetPin.invalidLength' }));
    if (pin !== confirmation)
      return setError(intl.formatMessage({ id: 'publicReservation.pinsDoNotMatch' }));
    const token = params.get('token');
    if (!token) return setError(intl.formatMessage({ id: 'resetPin.missingToken' }));
    mutate({ token, pin }, { onError: e => setError(e.message) });
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Stack spacing={2} component="form" onSubmit={submit}>
          <Typography variant="h5" fontWeight={700}>
            <FormattedMessage id="resetPin.title" />
          </Typography>
          {isSuccess ? (
            <>
              <Alert severity="success">
                <FormattedMessage id="resetPin.success" />
              </Alert>
              <Button variant="contained" onClick={() => navigate('/customer-reservations/login')}>
                <FormattedMessage id="resetPin.goToLogin" />
              </Button>
            </>
          ) : (
            <>
              {error && <Alert severity="error">{error}</Alert>}
              <TextField
                label={intl.formatMessage({ id: 'resetPin.newPin' })}
                type="password"
                value={pin}
                onChange={e => setPin(e.target.value)}
                required
                autoFocus
              />
              <TextField
                label={intl.formatMessage({ id: 'resetPin.confirmNewPin' })}
                type="password"
                value={confirmation}
                onChange={e => setConfirmation(e.target.value)}
                required
              />
              <Button
                type="submit"
                variant="contained"
                disabled={isPending}
                startIcon={isPending ? <CircularProgress size={18} /> : undefined}
              >
                <FormattedMessage id="resetPin.save" />
              </Button>
            </>
          )}
        </Stack>
      </Paper>
    </Container>
  );
};
